import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import FileCMSModel from '@/visa-application/models/FileCMSModel';
import ApplicationCenterCMSModel from '@/visa-application/models/ApplicationCenterCMSModel';
import TravelPurposeThemeCMSModel from '@/visa-application/models/TravelPurposeThemeCMSModel';
import VisaTypesContentCMSModel from '@/visa-application/models/VisaTypesContentCMSModel';

export default class VisaTypeCMSModel implements CMSModel {
  is_active: boolean;
  disable_confirm: boolean;
  account_type = '';
  code = '';
  stay = '';
  travel_purpose_theme: TravelPurposeThemeCMSModel = new TravelPurposeThemeCMSModel();
  applicationCenter: ApplicationCenterCMSModel = new ApplicationCenterCMSModel();
  visa_types_content: VisaTypesContentCMSModel = new VisaTypesContentCMSModel();
  title = '';
  description = '';
  document_link = '';
  document: FileCMSModel = new FileCMSModel();
  weight: number;
  form_downloadable: boolean;
  active_afp_payment = '';
  popup_details = '';

  map(obj: any): void {
    this.is_active = _.get(obj, 'is_active', true);
    this.disable_confirm = _.get(obj, 'disable_confirm', true);
    this.account_type = _.get(obj, 'account_type', '');
    this.code = _.get(obj, 'code', '');
    this.stay = _.get(obj, 'stay', '');
    this.travel_purpose_theme.map(_.get(obj, 'travel_purpose_theme', ''));
    this.applicationCenter.map(_.get(obj, 'application_center', ''));
    this.visa_types_content.map(_.get(obj, 'visa_types_content', ''));
    this.title = _.get(obj, 'translation[0].title', '') || this.visa_types_content.title;
    this.description = _.get(obj, 'translation[0].description', '');
    this.document_link = _.get(obj, 'translation[0].document_link', '');
    this.document.map(_.get(obj, 'translation[0].document', ''));
    this.popup_details = _.get(obj, 'translation[0].popup_details', '');
    this.weight = _.get(obj, 'weight', 0);
    this.form_downloadable = _.get(obj, 'form_downloadable', false);
    this.active_afp_payment = _.get(obj, 'active_afp_payment', false);
  }
}
